"use client";

import React, { useEffect, useRef, useState } from "react";

import TrustedPartners from "../TrustedPartners";
import GlobalPartnersCount from "@/components/GlobalPartnersCount";
import Image, { StaticImageData } from "next/image";
import aboutusImage from '../../images/AboutUsPage.webp'
import { AboutUsDot as Icon_AboutUsDot } from "@/components/customer/icons/AboutUsDot";
import { AboutUsInsta as Icon_AboutUsInsta } from "@/components/customer/icons/AboutUsInsta";
import { AboutUsLinkedIn as Icon_AboutUsLinkedIn } from "@/components/customer/icons/AboutUsLinkedIn";
import { AboutUsX as Icon_AboutUsX } from "@/components/customer/icons/AboutUsX";
import { CoreCommitment as Icon_CoreCommitment } from "@/components/customer/icons/CoreCommitment";
import { CoreGrowth as Icon_CoreGrowth } from "@/components/customer/icons/CoreGrowth";
import { CoreOwnership as Icon_CoreOwnership } from "@/components/customer/icons/CoreOwnership";
import { CorePositivity as Icon_CorePositivity } from "@/components/customer/icons/CorePositivity";
import { CoreTeamwork as Icon_CoreTeamwork } from "@/components/customer/icons/CoreTeamwork";
import { CoreValueInnovation as Icon_CoreValueInnovation } from "@/components/customer/icons/CoreValueInnovation";
const SvgIcons = { AboutUsDot: Icon_AboutUsDot, AboutUsInsta: Icon_AboutUsInsta, AboutUsLinkedIn: Icon_AboutUsLinkedIn, AboutUsX: Icon_AboutUsX, CoreCommitment: Icon_CoreCommitment, CoreGrowth: Icon_CoreGrowth, CoreOwnership: Icon_CoreOwnership, CorePositivity: Icon_CorePositivity, CoreTeamwork: Icon_CoreTeamwork, CoreValueInnovation: Icon_CoreValueInnovation };

import { useAOS } from '@/hooks/useAOS';


import Link from "next/link";



import aboutBg from '../../public/images/aboutus bg.webp'

import TimelineSection from "./TimelineSection";
// Old testimonials component no longer used here — unified to CircularTestimonialView
// import Testimonials from "../Testimonials";
import AboutTestimonials from "./AboutTestimonials";
import { getImageUrl } from "@/lib/imageUrl";

const About = () => {
  // Animation for stats: ensure animation runs on first page load
  const [years, setYears] = useState(0);
  const [customers, setCustomers] = useState(0);
  const [projects, setProjects] = useState(0);
  const [hasAnimated, setHasAnimated] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);




  useEffect(() => {
    // prefers-reduced-motion: show the real numbers immediately rather than counting up.
    // Matches the check already used in hooks/useAOS.ts.
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches) {
      setYears(10);
      setCustomers(1000);
      setProjects(50);
      setHasAnimated(true);
      return;
    }
    // Only animate once, when the section is in view
    const observer = new window.IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated) {
          setHasAnimated(true);
          const duration = 2000;
          const steps = 50;
          const yearsTarget = 10;
          const customersTarget = 1000;
          const projectsTarget = 50;

          const yearsStep = yearsTarget / steps;
          const customersStep = customersTarget / steps;
          const projectsStep = projectsTarget / steps;
          const intervalTime = duration / steps;

          let currentStep = 0;

          const interval = setInterval(() => {
            currentStep++;
            setYears((prev) => {
              const next = prev + yearsStep;
              return next >= yearsTarget ? yearsTarget : next;
            });
            setCustomers((prev) => {
              const next = prev + customersStep;
              return next >= customersTarget ? customersTarget : next;
            });
            setProjects((prev) => {
              const next = prev + projectsStep;
              return next >= projectsTarget ? projectsTarget : next;
            });
            if (currentStep >= steps) {
              clearInterval(interval);
              setYears(yearsTarget);
              setCustomers(customersTarget);
              setProjects(projectsTarget);
            }
          }, intervalTime);
        }
      },
      // Was 0.3. sectionRef wraps the h1 + lead + 850x480 image + stats grid, roughly
      // 2000-2500px tall on a phone against a ~700px viewport, so intersectionRatio could
      // never reach 0.3 and the counters sat at 0+ / 0+ / 0+ permanently. Any sliver counts.
      { threshold: 0 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, [hasAnimated]);



  useAOS();

  return (
    <div className="overflow-hidden">


      <div className="md:py-[80px] py-[40px] bg-[linear-gradient(106deg,#FCF5FF_15.18%,#F2F6FC_90.56%)]">
        <div
          ref={sectionRef}
          className="px-4 md:px-4 md:container gap-[60px] "
        >
          <h1 data-aos-now className="text-dark text-center mb-[16px] text-[40px] md:text-[50px] lg:text-[56px] leading-[120%] font-normal font-NeueMontreal not-italic">
            <span className="bg-[linear-gradient(90deg,_#1557FF_0%,_#29ACE8_100%)] bg-clip-text text-transparent text-[40px] md:text-[50px] lg:text-[56px] leading-[120%] font-normal font-NeueMontreal not-italic">
              Meet the Minds{" "}
            </span>
            Behind the Magic of Vilva
          </h1>
          <p data-aos-now className="text-text-dark text-center text-[#373844]   text-[18px] leading-[150%] w-full mx-auto md:w-[75%] font-[400] schibsted-grotesk not-italic">
            We’re a small, sharp team of builders and dreamers, turning big ideas into everyday digital experiences.We build powerful digital tools that simplify lives, speed up businesses, and connect communities.
          </p>

          <div className="w-full ">
            <Image
              data-aos-now
              data-aos-duration="1000"
              src={aboutusImage}
              alt="About us section image"
              width={850}
              height={480}
              sizes="(max-width: 768px) 100vw, (max-width: 1024px) 550px, 850px"
              className="w-full md:w-[550px] mx-auto lg:w-[850px] my-[48px] h-auto object-cover"
              priority
            />
          </div>
          <div className="w-full md:w-[50%] mx-auto ">

            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-2 lg:grid-cols-3 items-center flex-wrap gap-[32px]">
              <div className="border-r border-r-[#B9CDEC]  md:pe-[32px] md:me-[32px]">
                <div className="flex items-center  flex-col justify-center">
                  <div className="p-0 m-0 font-bold mb-1 ">
                    <span className="text-[#195AFF] text-[48px] font-bold  font-NeueMontreal text-start">
                      {Math.round(years)}+
                    </span>
                  </div>
                  <p data-aos-now className="p-0 m-0 text-[#090D28]  text-[18px] font-medium leading-[100%] font-NeueMontreal">
                    Years in business
                  </p>
                </div>
              </div>
              <div className="border-r-0 sm:border-r md:border-r-0 lg:border-r border-r-[#B9CDEC]  md:pe-[32px] md:me-[32px]">
                <div className="flex items-center flex-col justify-center ">
                  <div className="p-0 m-0 font-bold mb-1">
                    <span className="text-[#195AFF] text-[48px] font-bold leading-[150%] font-NeueMontreal text-center">
                      {Math.round(customers)}+
                    </span>
                  </div>
                  <p data-aos-now className="p-0 m-0 text-[#090D28] text-[18px] font-medium leading-[100%] font-NeueMontreal">
                    Happy Customers
                  </p>
                </div>
              </div>
              <div className=" w-full">
                <div className="flex items-center flex-col justify-center">
                  <div className="p-0 m-0 font-bold mb-1 ">
                    <span className="text-[#195AFF] text-[48px] font-bold leading-[150%] font-NeueMontreal text-start">
                      {Math.round(projects)}+
                    </span>
                  </div>
                  <p data-aos-now className="p-0 m-0 text-[#090D28] text-[18px] font-medium leading-[100%] font-NeueMontreal">
                    Projects Delivered
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



      <section className=" md:py-[80px] py-[40px] px-[24px] relative z-10">

        <div className="bg-[linear-gradient(180deg,_#F0F7FF_0%,_#FFF_100%)] h-[723px] w-[723px] rounded-full absolute -z-10 -right-[300px]">

        </div>

        <div className="mb-[32px]">
          <h2 className=" text-center font-NeueMontreal text-[32px] md:text-[48px] font-normal leading-[100%] bg-[linear-gradient(90deg,_#05B_0%,_#002755_100%)] bg-clip-text text-transparent">
            The Humans of Vilva
          </h2>

          <div className="w-full px-0 md:px-36 my-[20px]">
            <p className="text-[#0D2970] schibsted-groteskitalic font-[600]  md:w-[85%] w-[100%] mx-auto text-[24px] md:text-[28px] text-center leading-[140%]">"At Vilva, our people are the product. Every line of code, every pixel, every strategy carries a heartbeat. <span className="text-[#9AA3BB] schibsted-groteskitalic font-[600] text-[24px] md:text-[28px] leading-[140%]">We’re dreamers who design, doers who deliver, and everyday humans solving real problems for real people."</span></p>
          </div>

          <div className="grid px-0 md:px-36 grid-cols-1 md:grid-cols-4 gap-[48px]">

            <div>
              <div>
                <Image
                  src={getImageUrl("/vilvabusiness/website/common/vilvaboys-image/Gopinath.webp")}
                  alt="Gopinath Ravirajan, CEO of Vilva Business"
                  width={400}
                  height={500}
                  sizes="(max-width: 768px) 100vw, 400px"
                  className="mx-auto object-cover"
                  loading="lazy"
                />
                <div>
                  <p className="text-[var(--Dark-Color,#090D28)] mt-[16px]  mb-[8px] text-center font-LatinkaSemiBold text-[20px] not-italic font-[400] leading-[100%]">Gopinath Ravirajan</p>
                  <p className="text-[#6C7085] text-center mb-[8px] schibsted-grotesk text-[16px] not-italic font-[400] leading-[100%]">CEO</p>

                  <div className="flex items-center justify-center gap-2">
                    <Link href={"https://www.instagram.com/gopinath_technopreneur"} target="_blank" aria-label="Gopinath Instagram Profile">
                      <SvgIcons.AboutUsInsta />
                    </Link>
                    <Link href={"https://www.linkedin.com/in/gopinathravirajan"} target="_blank" aria-label="Gopinath LinkedIn Profile">
                      <SvgIcons.AboutUsLinkedIn />
                    </Link>
                    {/* <Link href={""} target="_blank">
                      <SvgIcons.AboutUsX/>
                      </Link> */}
                  </div>
                  <Link
                    href="/founder"
                    className="mt-3 block text-center font-Schibsted_Grotesk text-[14px] font-semibold text-[#195AFF] hover:underline"
                  >
                    Read his full story &rarr;
                  </Link>
                </div>
              </div>
            </div>
            <div>
              <div> 
                <Image
                  src={getImageUrl("/vilvabusiness/website/common/vilvaboys-image/Govind.webp")}
                  alt="Govindaraj, Operational Manager of Vilva Business"
                  width={400}
                  height={500}
                  sizes="(max-width: 768px) 100vw, 400px"
                  className="mx-auto object-cover"
                  loading="lazy"
                />
                <div>
                  <p className="text-[var(--Dark-Color,#090D28)] mt-[16px]  mb-[8px] text-center font-LatinkaSemiBold text-[20px] not-italic font-[400] leading-[100%]">Govindaraj</p>
                  <p className="text-[#6C7085] text-center mb-[8px] schibsted-grotesk text-[16px] not-italic font-[400] leading-[100%]">Operational Manager</p>

                  {/* Social links removed: were href="#" dead links (no real profile URLs).
                      Re-add with real Instagram/LinkedIn URLs when available. */}
                </div>
              </div>
            </div>
            <div>
              <div>
                <Image
                  src={getImageUrl("/vilvabusiness/website/common/vilvaboys-image/Bharath.webp")}
                  alt="Bharath Srinath, Operations Executive of Vilva Business"
                  width={400}
                  height={500}
                  sizes="(max-width: 768px) 100vw, 400px"
                  className="mx-auto object-cover"
                  loading="lazy"
                />

                <div>
                  <p className="text-[var(--Dark-Color,#090D28)] mt-[16px]  mb-[8px] text-center font-LatinkaSemiBold text-[20px] not-italic font-[400] leading-[100%]">Bharath Srinath</p>
                  <p className="text-[#6C7085] text-center mb-[8px] schibsted-grotesk text-[16px] not-italic font-[400] leading-[100%]">Operations Executive</p>

                  <div className="flex items-center justify-center gap-2">
                    <Link href={"https://www.instagram.com/bharathsrinath94"} target="_blank" aria-label="Bharath Srinath Instagram Profile">
                      <SvgIcons.AboutUsInsta />
                    </Link>
                    <Link href={"https://www.linkedin.com/in/bharathsrinath"} target="_blank" aria-label="Bharath Srinath LinkedIn Profile">
                      <SvgIcons.AboutUsLinkedIn />
                    </Link>
                    <Link href={"https://x.com/Bharath_Srinath"} target="_blank" aria-label="Bharath Srinath X Profile">
                      <SvgIcons.AboutUsX />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div>
                <Image
                  src={getImageUrl("/vilvabusiness/website/common/vilvaboys-image/Pavan.webp")}
                  alt="Pavankumar, Digital Marketing Executive of Vilva Business"
                  width={400}
                  height={500}
                  sizes="(max-width: 768px) 100vw, 400px"
                  className="mx-auto object-cover"
                  loading="lazy"
                />

                <div>
                  <p className="text-[var(--Dark-Color,#090D28)] mt-[16px]  mb-[8px] text-center font-LatinkaSemiBold text-[20px] not-italic font-[400] leading-[100%]">Pavankumar</p>
                  <p className="text-[#6C7085] text-center mb-[8px] schibsted-grotesk text-[16px] not-italic font-[400] leading-[100%]">Digital Marketing Executive</p>

                  <div className="flex items-center justify-center gap-2">
                    <Link href={"https://www.instagram.com/pavanraju159/"} target="_blank" aria-label="Pavankumar Instagram Profile">
                      <SvgIcons.AboutUsInsta />
                    </Link>
                    <Link href={"https://www.linkedin.com/in/pavan-raju-83b40b234/ "} target="_blank" aria-label="Pavankumar LinkedIn Profile">
                      <SvgIcons.AboutUsLinkedIn />
                    </Link>
                    {/* <Link href={""} target="_blank">
                      <SvgIcons.AboutUsX/>
                      </Link> */}
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>

      </section>


      <TimelineSection />



      <section className="container relative  py-[80px] md:py-[80px]">

        <Image src={aboutBg} alt="about Bg" className="absolute bottom-0 z-40"></Image>


        {/* <div className="mb-[80px]  hidden md:block overflow-hidden">

          <div
            className="relative after:absolute after:inset-x-0 after:top-5 after:block after:h-[3px] after:-translate-y-1/2 after:rounded-lg after:bg-[linear-gradient(90deg,rgba(183,194,221,0)0%,#B7C2DD_22.6%,#B7C2DD_79.33%,rgba(183,194,221,0)100%)]"
          >
            <ol className="relative container  z-10 flex justify-between text-sm font-medium text-gray-500">
              <li className="flex items-center gap-2 z-50 relative md:left-[40px] lg:left-[80px] p-2">
                <div data-aos="fade-right" data-aos-duration="800" className="flex  timeline-item justify-center flex-col items-center">
                  <div className="!relative flex justify-center w-[150px] !z-50 bg-[linear-gradient(90deg,transparent_0%,#FFF_50%,transparent_100%)]">
                    <SvgIcons.AboutUsDot className="relative !z-50" />

                  </div>
                  <p className="text-[#195AFF] text-center text-[16px] leading-[100%] font-normal font-LatinkaSemiBold pb-[6px]">Apr 16th, 2015</p>
                  <p className="text-[#516AAB] text-[14px] leading-[120%] font-normal schibsted-grotesk">Founded</p>
                </div>

              </li>

              <li className="flex items-center gap-2 relative md:left-[52px] lg:left-[140px] p-2">
                <div data-aos="fade-right" data-aos-duration="800" className="flex timeline-item justify-center flex-col items-center">
                  <div className="!relative flex justify-center w-[150px] !z-50 bg-[linear-gradient(90deg,transparent_0%,#FFF_50%,transparent_100%)]">
                    <SvgIcons.AboutUsDot className="relative !z-50" />


                  </div>
                  <p className="text-[#195AFF] text-center text-[16px] leading-[100%] font-normal font-LatinkaSemiBold   pb-[6px]">Mar 14th, 2019</p>
                  <p className="text-[#516AAB] text-[14px] leading-[120%] font-normal schibsted-grotesk">Opened Kodungiyur Head Office</p>
                </div>
              </li>

              <li className="flex items-center gap-2  p-2">
                <div data-aos="fade-right" data-aos-duration="800" className="flex timeline-item justify-center flex-col items-center">
                  <div className="!relative flex justify-center w-[150px] !z-50 bg-[linear-gradient(90deg,transparent_0%,#FFF_50%,transparent_100%)]">
                    <SvgIcons.AboutUsDot className="relative !z-50" />


                  </div>
                  <p className="text-[#195AFF] text-center text-[16px] leading-[100%] font-normal font-LatinkaSemiBold pb-[6px]">Aug 22th, 2024</p>
                  <p className="text-[#516AAB] text-[14px] leading-[120%] font-normal schibsted-grotesk">Opened Ambattur Tech Office</p>
                </div>
              </li>
            </ol>
          </div>
        </div>

        <div className="mb-[80px] md:hidden block overflow-hidden">

          <div
            className="relative "
          >

            <ol className="relative  z-10 block text-sm font-medium text-gray-500">
              <div className="h-full left-[32px] rounded-[50%] top-0 w-[3px] absolute bg-[linear-gradient(90deg,rgba(183,194,221,0)0%,#B7C2DD_22.6%,#B7C2DD_79.33%,rgba(183,194,221,0)100%)]">

              </div>
              <li data-aos="fade-down" data-aos-duration="800" className="flex items-start time-upline-item gap-2 z-50 relative  p-2">
                <div className="flex">
                  <div className="!relative flex justify-center items-center w-[50px] h-[100px] p-2 !z-50 bg-[linear-gradient(to_bottom,rgba(255,255,255,0)_0%,#ffffff_50%,rgba(255,255,255,0)_100%)]">
                    <SvgIcons.AboutUsDot className="relative !z-50" />



                  </div>
                  <div className="flex flex-col justify-center items-start pt-3">
                    <p className="text-[#195AFF] text-center text-[16px] leading-[100%] font-normal font-LatinkaSemiBold   pb-[6px]">Apr 16th, 2015</p>
                    <p className="text-[#516AAB] text-[14px] leading-[120%] font-normal schibsted-grotesk">Founded</p>
                  </div>
                </div>

              </li>

              <li data-aos="fade-down" data-aos-duration="800" className="flex mt-10 time-upline-item items-start gap-2 z-50 relative  p-2">
                <div className="flex">
                  <div className="!relative flex justify-center items-center w-[50px] h-[100px] p-2 !z-50 bg-[linear-gradient(to_bottom,rgba(255,255,255,0)_0%,#ffffff_50%,rgba(255,255,255,0)_100%)]">
                    <SvgIcons.AboutUsDot className="relative !z-50" />



                  </div>
                  <div className="flex flex-col justify-center items-start pt-3">
                    <p className="text-[#195AFF] text-center text-[16px] leading-[100%] font-normal font-LatinkaSemiBold pb-[6px]">Mar 14th, 2019</p>
                    <p className="text-[#516AAB] text-[14px] leading-[120%] font-normal schibsted-grotesk">Opened Kodungiyur Head Office</p>
                  </div>
                </div>

              </li>

              <li data-aos="fade-down" data-aos-duration="800" className="flex items-start time-upline-item gap-2 z-50 relative  p-2">
                <div className="flex">
                  <div className="!relative flex justify-center items-center w-[50px] h-[100px] p-2 !z-50 bg-[linear-gradient(to_bottom,rgba(255,255,255,0)_0%,#ffffff_50%,rgba(255,255,255,0)_100%)]">
                    <SvgIcons.AboutUsDot className="relative !z-50" />



                  </div>
                  <div className="flex flex-col justify-center items-start pt-3">
                    <p className="text-[#195AFF] text-center text-[16px] leading-[100%] font-normal font-LatinkaSemiBold pb-[6px]">Aug 22th, 2024</p>
                    <p className="text-[#516AAB] text-[14px] leading-[120%] font-normal schibsted-grotesk">Opened Ambattur Tech Office</p>
                  </div>
                </div>

              </li>
            </ol>
          </div>
        </div> */}
        <div className="block md:flex items-start gap-[80px]">
          <div className="w-full md:w-1/2">
            <p className="text-[#373844] text-[18px] md:text-[18px] leading-[150%] font-normal schibsted-grotesk not-italic">At Vilva Business, we are passionate about delivering innovative solutions that propel businesses to new heights. As a leading technology company based in Chennai, India, we specialize in crafting tailored services and cutting-edge products to meet the evolving needs of our clients. With a relentless focus on quality, innovation, and customer satisfaction, we are your trusted partner in achieving lasting success.</p>
            <h2 className="text-[#0D2970] my-[32px] w-full z-50 relative   md:mt-[64px] text-[32px]  md:text-[48px] leading-[100%] font-normal font-NeueMontreal">
              How Vilva Started?
            </h2>
          </div>
          <p className="text-[#373844] w-full z-50 relative md:w-1/2 text-[18px] md:text-[18px]  leading-[150%] font-normal schibsted-grotesk not-italic ">Vilva Business was founded by Mr. Gopinath Ravirajan, a visionary Tamil entrepreneur with a passion for innovation and cultural impact. Before establishing Vilva Business, Gopinath gained recognition for promoting Tamil language and heritage through a venture focused on Tamil-themed T-shirts, as highlighted in a 2016 YourStory article. His commitment to blending cultural pride with entrepreneurial spirit laid the foundation for Vilva Business, where he now drives technological transformation for global clients. Under his leadership, Vilva Business has completed over 500 projects and served 100+ clients worldwide, delivering solutions like AI-powered CRM, WhatsApp automation, and scalable e-commerce platforms.</p>
        </div>
      </section>
      <section className="px-4  md:container py-[80px] md:py-[120px]">
        <h2 data-aos="slide-up" data-aos-duration="2000" className="text-[#090D28] text-center font-NeueMontreal text-[32px] mb-[48px] md:text-[48px] font-normal leading-[120%]">The Core Values That Drive Vilva</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[24px]">
          <div data-aos="fade-right" data-aos-duration="800" className="core-value-card rounded-3xl bg-[#EFFCE9] p-6">
            <SvgIcons.CoreValueInnovation />
            <p className="text-[#5BBE2A] py-[16px] text-[22px] leading-[120%] font-bold schibsted-grotesk">
              Innovation
            </p>
            <p className="text-[#373844] text-[18px] leading-[150%] font-normal schibsted-grotesk">
              We embrace emerging technologies and creative thinking to deliver
              future-ready products that give our clients a competitive edge.
            </p>
          </div>
          <div data-aos="fade-right" data-aos-duration="800" className="core-value-card rounded-3xl bg-[#E9F5FC] p-6">
            <SvgIcons.CoreGrowth />
            <p className="text-[#157FE3] py-[16px] text-[22px] leading-[120%] font-bold schibsted-grotesk">
              Growth
            </p>
            <p className="text-[#373844] text-[18px] leading-[150%] font-normal schibsted-grotesk">
              We focus on building scalable and efficient solutions that fuel real
              business growth and long-term success.
            </p>
          </div>
          <div data-aos="fade-right" data-aos-duration="800" className="core-value-card rounded-3xl bg-[#FCF9E9] p-6">
            <SvgIcons.CoreOwnership />
            <p className="text-[#B67D19] py-[16px] text-[22px] leading-[120%] font-bold schibsted-grotesk">
              Ownership
            </p>
            <p className="text-[#373844] text-[18px] leading-[150%] font-normal schibsted-grotesk">
              From start to finish, we own every detail ensuring accountability,
              quality, and on-time delivery.
            </p>
          </div>
          <div data-aos="fade-right" data-aos-duration="800" className="core-value-card rounded-3xl bg-[#FDF2F7] p-6">
            <SvgIcons.CoreTeamwork />
            <p className="text-[#E52F69] py-[16px] text-[22px] leading-[120%] font-bold schibsted-grotesk">
              Teamwork
            </p>
            <p className="text-[#373844] text-[18px] leading-[150%] font-normal schibsted-grotesk">
              We work hand-in-hand across roles and ideas, building synergy that
              leads to smarter, smoother execution.
            </p>
          </div>
          <div data-aos="fade-right" data-aos-duration="800" className="core-value-card rounded-3xl bg-[#E9FCF6] p-6">
            <SvgIcons.CoreCommitment />
            <p className="text-[#1CAF80] py-[16px] text-[22px] leading-[120%] font-bold schibsted-grotesk">
              Commitment
            </p>
            <p className="text-[#373844] text-[18px] leading-[150%] font-normal schibsted-grotesk">
              Our word is our bond. We prioritize reliability and consistency in
              every phase of the project.
            </p>
          </div>
          <div data-aos="fade-right" data-aos-duration="800" className="core-value-card rounded-3xl bg-[#F3EDFC] p-6">
            <SvgIcons.CorePositivity />
            <p className="text-[#8245DC] py-[16px] text-[22px] leading-[120%] font-bold schibsted-grotesk">
              Positivity
            </p>
            <p className="text-[#373844] text-[18px] leading-[150%] font-normal schibsted-grotesk">
              We face challenges with optimism, fostering a supportive, high-energy
              environment for both team and clients.
            </p>
          </div>
        </div>
      </section>
      <section className="px-4 0 md:container py-[40px] md:py-[80px]">
        <div className="block lg:flex items-start ">

          <div className="lg:w-5/12 w-full border-r-0 lg:border-r-2 lg:border-[#E4E9F0]  pr-0 mr0 lg:pr-[52px] lg:mr-[52px] " >
            <h3 className="text-[#090D28]  text-[28px] md:text-[32px] leading-[120%] font-bold schibsted-grotesk mb-[16px]">Our Mission</h3>
            <p className="text-[#373844] text-[18px] leading-[150%] font-normal schibsted-grotesk mb-[40px]">To empower businesses with innovative, scalable, and accessible technology solutions that simplify operations and accelerate growth.
            </p>
            <h3 className="text-[#090D28]  text-[28px] md:text-[32px] leading-[120%] font-bold schibsted-grotesk mb-[16px]">Our Vision</h3>
            <p className="text-[#373844] text-[18px] leading-[150%] font-normal schibsted-grotesk mb-[40px]">To be a global leader in digital transformation, providing intuitive and impactful solutions that redefine how businesses operate and engage with their customers.</p>
          </div>


          <div className="lg:w-7/12 w-full" >

            <AboutTestimonials />
            {/* <div>
            <div className='overflow-hidden'>
              <Swiper
                className='container mb-5'
                modules={[Navigation, Autoplay]}
                autoplay={{
                  delay: 5000,
                  disableOnInteraction: false,
                }}
                speed={3000}
                loop={true}
                spaceBetween={24}
                slidesPerView={1}
                navigation={{
                  prevEl: '.seo-swiper-prev',
                  nextEl: '.seo-swiper-next',
                }}
                breakpoints={{
                  768: {
                    slidesPerView: 1,
                    spaceBetween: 24,
                  },
                  1024: {
                    slidesPerView: 1,
                    spaceBetween: 24,
                  },
                }}
                onInit={swiper => {
                  // @ts-ignore
                  swiper.params.navigation.prevEl = '.seo-swiper-prev';
                  // @ts-ignore
                  swiper.params.navigation.nextEl = '.seo-swiper-next';
                  swiper.navigation.init();
                  swiper.navigation.update();
                }}
              >
                {
                  cards.map((card: any) => (
                    <SwiperSlide key={card?.id}>
                      <div
                        className="flex w-full h-[350px]  p-[32px] flex-col justify-between items-start flex-shrink-0 rounded-[16px] border border-[#E4E9F0] bg-white shadow-[0px_68px_19px_0px_rgba(0,9,56,0),0px_43px_17px_0px_rgba(0,9,56,0),0px_24px_15px_0px_rgba(0,9,56,0.01),0px_11px_11px_0px_rgba(0,9,56,0.02),0px_3px_6px_0px_rgba(0,9,56,0.02)]"
                      >
                        <p className="text-[#090D28] text-[16px] md:text-[24px]  leading-[150%] font-LatinkaSemiBold">
                          {card.front.text}
                        </p>
                        <div className="flex gap-4 items-center">
                          <img
                            className="object-cover w-14 h-14 rounded-full"
                            src={card.front.avatar.src}
                            alt={`${card.front.store} avatar`}
                          />
                          <div>
                            <p className="text-[#090D28] whitespace-nowrap p-0 m-0 mb-1 text-[16px] font-medium leading-none font-LatinkaMedium">
                              {card.front.store}
                            </p>
                            <p className="text-[#666] text-[12px] md:text-[14px] p-0 m-0 font-normal leading-none schibsted-grotesk">
                              {card.front.title}
                            </p>
                          </div>
                        </div>
                      </div>

                    </SwiperSlide>
                  ))
                }
              </Swiper>
              <div className="flex justify-center items-center mt-[16px] gap-2">
                <button
                  type="button"
                  className="seo-swiper-prev flex aspect-[1/1] h-[36px] w-[36px] items-center justify-center rounded-[18px] border border-[#E4E9F0] bg-white p-2 shadow-[0px_68px_19px_0px_rgba(0,9,56,0),0px_43px_17px_rgba(0,9,56,0),0px_24px_15px_rgba(0,9,56,0.01),0px_11px_11px_rgba(0,9,56,0.02),0px_3px_6px_rgba(0,9,56,0.02)]"
                  tabIndex={0}
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='20'
                    height='20'
                    viewBox='0 0 20 20'
                    fill='none'
                  >
                    <path
                      d='M12.5 15L7.5 10L12.5 5'
                      stroke='black'
                      strokeWidth='1.25'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                  </svg>
                </button>
                <button
                  type="button"
                  className="seo-swiper-next flex aspect-[1/1] h-[36px] w-[36px] items-center justify-center rounded-[18px] border border-[#E4E9F0] bg-white p-2 shadow-[0px_68px_19px_0px_rgba(0,9,56,0),0px_43px_17px_rgba(0,9,56,0),0px_24px_15px_rgba(0,9,56,0.01),0px_11px_11px_0px_rgba(0,9,56,0.02),0px_3px_6px_rgba(0,9,56,0.02)]"
                  tabIndex={0}
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='20'
                    height='20'
                    viewBox='0 0 20 20'
                    fill='none'
                  >
                    <path
                      d='M7.5 15L12.5 10L7.5 5'
                      stroke='black'
                      strokeWidth='1.25'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                  </svg>
                </button>
              </div>
            </div>
            </div> */}
          </div>
        </div>

      </section>
      <TrustedPartners className="relative py-[20px]" />
    </div>
  );
};

export default About;